import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { resultMonths, resultTypes, results } from "@/mocks/results";

const typeStyles: Record<string, string> = {
  警告并整改: "bg-secondary-100 text-secondary-900 border-secondary-200",
  限制开播: "bg-primary-100 text-primary-900 border-primary-200",
  内容下架: "bg-background-200 text-foreground-800 border-background-300",
  退还差额: "bg-accent-100 text-accent-900 border-accent-200",
  账号封禁: "bg-primary-200 text-primary-950 border-primary-300",
};

export default function ResultsExplorer() {
  const [type, setType] = useState("全部处置");
  const [month, setMonth] = useState("全部月份");

  const filtered = useMemo(
    () =>
      results.filter((item) => {
        const matchType = type === "全部处置" || item.resultType === type;
        const matchMonth = month === "全部月份" || item.handledAt.startsWith(month);
        return matchType && matchMonth;
      }),
    [type, month],
  );

  return (
    <div>
      <div className="bg-background-100 border border-background-200 rounded-lg p-4 md:p-5">
        <div className="flex flex-wrap gap-2">
          {resultTypes.map((item) => {
            const active = type === item;
            return (
              <button
                key={item}
                type="button"
                onClick={() => setType(item)}
                aria-pressed={active}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  active
                    ? "bg-foreground-950 text-background-50"
                    : "bg-background-50 text-foreground-700 border border-background-200 hover:border-primary-300 hover:text-foreground-950"
                }`}
              >
                {item}
              </button>
            );
          })}
        </div>
        <div className="mt-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-sm text-foreground-600">
            共 <strong className="font-heading text-foreground-950">{filtered.length}</strong> 条处理结果公示
          </p>
          <select
            value={month}
            onChange={(event) => setMonth(event.target.value)}
            className="sm:w-44 px-3.5 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/30 transition-colors"
          >
            {resultMonths.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
      </div>

      {filtered.length > 0 ? (
        <ul className="mt-6 border border-background-200 rounded-lg overflow-hidden divide-y divide-background-200 bg-background-50">
          {filtered.map((item) => (
            <li key={item.id} className="p-5 md:p-6 hover:bg-background-100 transition-colors">
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6">
                <div className="lg:col-span-8 min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <span
                      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full border text-xs font-medium whitespace-nowrap ${
                        typeStyles[item.resultType] ?? "bg-background-200 text-foreground-800 border-background-300"
                      }`}
                    >
                      <i className="ri-scales-3-line" aria-hidden="true"></i>
                      {item.resultType}
                    </span>
                    <span className="text-xs text-foreground-500">
                      {item.platform} · {item.category}
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug">
                    {item.eventId ? (
                      <Link to={`/events/${item.eventId}`} className="hover:text-primary-600 transition-colors">
                        {item.title}
                      </Link>
                    ) : (
                      item.title
                    )}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                </div>
                <div className="lg:col-span-4 lg:text-right text-xs text-foreground-500 space-y-1.5">
                  <p>公示编号：{item.id}</p>
                  <p>
                    完成时间：<span className="text-foreground-800">{item.handledAt}</span>
                  </p>
                  <p>
                    处置周期：<span className="text-foreground-800">{item.cycle}</span>
                  </p>
                  {item.eventId && (
                    <Link
                      to={`/events/${item.eventId}`}
                      className="inline-flex items-center gap-1.5 text-primary-600 hover:text-primary-700 transition-colors"
                    >
                      查看事件档案
                      <i className="ri-arrow-right-line" aria-hidden="true"></i>
                    </Link>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className="mt-6 bg-background-100 border border-background-200 rounded-lg py-16 text-center">
          <span className="mx-auto w-12 h-12 flex items-center justify-center rounded-full bg-background-200 text-foreground-500">
            <i className="ri-file-search-line text-2xl" aria-hidden="true"></i>
          </span>
          <p className="mt-4 text-base font-medium text-foreground-950">该条件下暂无公示结果</p>
          <p className="mt-2 text-sm text-foreground-600">试试切换处置类型或月份，也可以查看全部公示记录。</p>
          <button
            type="button"
            onClick={() => {
              setType("全部处置");
              setMonth("全部月份");
            }}
            className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium bg-foreground-950 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部公示
          </button>
        </div>
      )}
    </div>
  );
}